'use strict';

require('../core/core');
require('../../modules/forms/forms');
require('../../modules/maps/maps');

require('../../models/mountains/regions');
require('../../models/event/event');
require('../../models/event/eventReport');

require('../../forms/themes/inviteUser/inviteUser.theme');
require('../../forms/themes/typeaheadUser/typeaheadUser.theme');

require('../../forms/eventRequestForm');
require('../../forms/eventReportForm');
require('../../forms/eventGalleryForm');
require('../../forms/inviteUserForm');

require('../../helpers/show-modal-message/show-modal-message');

require('../fos_user/directives/unique-user');

require('../../modals/mountain-route-form/mountain-route-form');

require('./events-search.module');
require('../documents/documents.module');

require('../../modals/slider/slider');

angular.module('far.events', [
	'ngTouch',
	'dndLists',
	'ngMessages',
	'angularFileUpload',
	'ui.select',
	'ui.bootstrap',
	'dekky.forms',
	'dekky.forms.themes.typeaheadUser',
	'far.models.mountains.regions',
	'far.models.event.event',
	'far.models.event.eventReport',
	'far.core',
	'far.maps',
	'far.forms.eventRequestForm',
	'far.forms.eventReportForm',
	'far.forms.eventGalleryForm',
	'far.modals.mountain-route-form',
	'templates',
    'far.forms.inviteUserForm',
    'dekky.forms.themes.inviteUser',
    'far.helpers.showModalMessage',
    'far.fos_user.uniqueUser',
	'far.events.search',
	'far.documents.search',
	'far.modals.slider'
]).value('formsConfig', {
	theme: '/dekky.forms/themes/far'
}).run(function($templateCache) {
	$templateCache.put('/far.events/fields/partnersCollection.html',
		'<div ng-init="model = model || []" ng-model="model">' +
			'<div repeat-collection ng-init="fieldIndex = $index" ng-form="childForm">' +
				'<div class="form-group right">' +
					'<button class="btn-gold" type="button" ng-click="field.doDelete(item, model, $index)">{{ field.buttons.remove }}</button>' +
				'</div>' +
				'<form-row ng-model="item.name" field="field.childForm.$fields.name" field-index="fieldIndex"></form-row>' +
				'<p class="form__error" role="alert" ng-if="childForm.$$parentForm.$submitted && childForm.name.$error.required">Обязательное поле</p>' +
				'<form-row ng-model="item.url" field="field.childForm.$fields.url" field-index="fieldIndex"></form-row>' +
				'<p class="form__error" role="alert" ng-if="childForm.$$parentForm.$submitted" ng-messages="childForm.url.$error">' +
					'<span ng-message="required">Обязательное поле</span>' +
					'<span ng-message="url">Урл в неверном формате</span>' +
				'</p>' +
				'<form-row ng-model="item.logo" field="field.childForm.$fields.logo" field-index="fieldIndex"></form-row>' +
				'<div class="form__line"></div>' +
			'</div>' +

			'<div class="form-group">' +
				'<button class="btn-standart" type="button" ng-click="field.addItem(model)">{{ field.buttons.add }}</button>' +
			'</div>' +
		'</div>'
	);

	$templateCache.put('/far.events/fields/ascentCollection.html',
		'<div ng-init="model = model || []" ng-model="model">' +
			'<div class="page-item" repeat-collection>' +
				'<div class="page-spoiler ascent-item" ng-class="{\'page-spoiler_active\': showFormAscent}" ng-click="showFormAscent = !showFormAscent" ng-init="showFormAscent = true">Восхождение {{ $index + 1 }}</div>' +
				'<div ng-hide="!showFormAscent">' +
					'<form-row ng-model="item.ascent_date" field="field.childForm.$fields.ascent_date"></form-row>' +
					'<form-widget ng-model="item.ascent_mountain_peak" field="field.childForm.$fields.ascent_mountain_peak" ng-model-options="{ index: $index }"></form-widget>' +
					'<div class="form-group">' +
						'<form-widget ng-model="item.ascent_mountain_route" field="field.childForm.$fields.ascent_mountain_route" field-index="$index"></form-widget>' +
						// '<p class="form__description width-200">Если пройденного маршрута нет в базе, оставьте заявку на добавление нового маршрута перейдя по ссылке.</p>' +
						// '<a href="#" ng-click="field.mountainFormAdd($index)" class="btn-link">Добавить новый маршрут</a>' +
					'</div>' +
					'<div class="form-group margin_b_30">' +
						'<form-widget ng-model="item.ascent_type" field="field.childForm.$fields.ascent_type"></form-widget>' +
					'</div>' +
                    '<form-widget ng-model="item.instructor" field="field.childForm.$fields.instructor" ng-model-options="{ index: $index }"></form-widget>' +
					'<form-widget ng-model="item.user_chief" field="field.childForm.$fields.user_chief" ng-model-options="{ index: $index }"></form-widget>' +
					'<form-widget ng-model="item.users" field="field.childForm.$fields.ascent_users" template-url="/far.events/fields/ascentUsersCollection.html"></form-widget>' +
					'<button class="btn-gold" type="button" ng-click="field.doDelete(item, model, $index)">{{ field.buttons.remove }}</button>' +
                    '<button style="margin-left: 2em;" class="btn-gold" type="button" onclick="window.eventReportController.submit()">{{ field.buttons.save }}</button>' +
					'<button style="margin-left: 2em;" class="btn-link btn-copy-item" type="button" ng-click="field.form.vm.preCopyAscent($index); field.copyItem(item, model, $index)">{{ field.buttons.copy }}</button>' +
					'<div class="form__line"></div>' +
				'</div>' +
			'</div>' +

			'<a href="" ng-click="field.addItem(model)" class="btn-standart">Добавить восхождение</a>' +
		'</div>'
	);

	$templateCache.put('/far.events/fields/ascentUsersCollection.html',
		'<div ng-init="model = model || []" ng-model="model">' +
			'<div repeat-collection>' +
				'<div class="form-group right">' +
					'<button class="btn-gold" type="button" ng-click="field.doDelete(item, model, $index)">{{ field.buttons.remove }}</button>' +
				'</div>' +
				'<div class="form__ui-typeahead width-350">' +
					'<form-widget field="field.childForm.$fields.fio" ng-model="item.fio" field-data="item"></form-widget>' +
				'</div>' +
				'<form-widget field="field.childForm.$fields.email" ng-model="item.email"></form-widget>' +
			'</div>' +
			'<span ng-click="field.addItem(model)" class="btn-link margin_b_40">Добавить участника</span>' +
		'</div>'
	);
});
